import $ from "jquery";
import { breakpoint } from "../breakpoint";

const KEY_CODES = {
  tab: 9,
  enter: 13,
  leftArrow: 37,
  rightArrow: 39,
  upArrow: 38,
  downArrow: 40,
  esc: 27,
  space: 32
};


export class PrimaryNav {
  constructor($el) {
    this.$el =  $el;
    this.$navMenu = $el.find(".js-menu");
    this.$navItems = $el.find(".js-nav-item");
    this.$navToggle = $el.find(".js-nav-toggle");
    this.openClass = "is-open";

	  // Because of the dual hover/click nav interaction events,
    // there are times we may want to taker action to open/close
    // menus, but another event has beaten us to it. Use this
    // flag to lock out menu actions temporarily.
    this.menuActionLock = false;

    this.bindEvents();

    this.$navItems.each(this.adjustFlyoutMenuAlignment);

    // run any breakpoint changes immediately
    this.onBreakpointChange(breakpoint());
  }

  bindEvents() {

    this.$navItems.filter(".js-has-submenu").on("mouseenter", (event) => this.onMouseEnter(event));
    this.$navItems.filter(".js-has-submenu").on("mouseleave", (event) => this.onMouseLeave(event));
    this.$navItems.filter(".has-submenu").on("click", (event) => this.onItemClick(event));

    // Toggle entire navigation when hidden
    // in some viewports
    this.$navToggle.on("click", event => this.onNavToggleClick(event));

    // bind keypress events for keyboard navigation
    this.$navMenu.on("keydown", event => this.onKeyPress(event));

    // Add a document click handler to detect clicks
    // with the intent to dismiss navigation
    $(document).on("click", event => this.onOtherClick(event));
		
    // only fire responsive behaviors when the breakpoint changes
    let lastBp = "";
    let throttler;
    $(window).on("resize", event => {
      if (lastBp !== breakpoint()) {
        this.onBreakpointChange(breakpoint());
        lastBp = breakpoint();
      }
      // adjust the submenu alignment when the user stops resizing
      window.clearTimeout(throttler);
      throttler = setTimeout( () => {
        this.$navItems.each(this.adjustFlyoutMenuAlignment);
      }, 400);
    });

  }

  onNavToggleClick(event) {
    // Prevent this click from being counted
    // as a document click
    event.stopPropagation();
    this.$navToggle.toggleClass("is-open");
    this.toggleNavMenu();
  }

  onMouseLeave(event) {
    event.preventDefault();
    let $targetItem = $(event.target).closest(".js-nav-item");

    // set lock flag for any remaining event handlers in this event loop
    this.lockMenuAction();

    // Don't execute a menu toggle ion mouseleave if on mobile accordion
    if (!this.$navToggle.hasClass('is-open')) {
      this.operateSubMenu($targetItem);
    }
  }

  onMouseEnter(event) {
    event.preventDefault();
    let $targetItem = $(event.target).closest(".js-nav-item");

    // set lock flag for any remaining event handlers in this event loop
    this.lockMenuAction();
    this.operateSubMenu($targetItem);
  }

  onItemClick(event) {
    // Prevent this click from being counted
    // as a document click
    event.stopPropagation();

    // get the root nav item (we probably clicked on the child <a>)
    let $targetItem = $(event.target).closest(".js-nav-item");

    // Determine if the clicked target is the root level nav item, or one of the submenu items
    const targetIsSameAsItem = $(event.target).is($targetItem) || $(event.target).is($($targetItem.children(0)));
    const targetIsSubmenuLink = $.contains($targetItem.find(".js-submenu")[0], event.target);

    // only allow the underlying link to navigate to new page if...
    const allowLinkPassthrough = (
      !this.menuActionLock // ... menu is not locked
      && targetIsSameAsItem // ... AND click target is same as root item
      && $targetItem.hasClass("is-open") // ... AND menu is already open
      && !this.$navToggle.hasClass("is-open"))  // ... AND the click isn't coming from the mobile nav
      || targetIsSubmenuLink; // ... OR always pass through if we've clicked a submenu item

    if (!allowLinkPassthrough) {
      event.preventDefault();
    }

    if (!this.menuActionLock) {
      this.operateSubMenu($targetItem)
    }
  }

  onOtherClick(event) {
    if (breakpoint() === "large") {
      this.toggleFlyoutMenus([this.$openItem()]);
    }
  }

  onBreakpointChange(bp) {
    switch(bp) {
      case "large":
        this.$navMenu.show();
        this.ariaExpand(this.$el);
        break;
      case "medium":
      case "small":
        this.$el.removeClass(this.openClass);
        this.$navMenu.hide();
        this.ariaCollapse(this.$el);
        break;
      default:
        return;
    }
  }

  onKeyPress(event) {
    switch(event.which) {
      case KEY_CODES.enter:
      case KEY_CODES.space:
        this.toggleInContext(this.focusContext());
        break;
      case KEY_CODES.rightArrow:
        this.rightInContext(this.focusContext());
        break;
      case KEY_CODES.leftArrow:
        this.leftInContext(this.focusContext());
        break;
      case KEY_CODES.upArrow:
        this.upInContext(this.focusContext());
        break;
      case KEY_CODES.downArrow:
        this.downInContext(this.focusContext());
        break;
      case KEY_CODES.esc:
        this.collapseInContext(this.focusContext());
        break;
      default:
        return;
    }
  }

  lockMenuAction() {
    // On touch devices, nav will fire both mouseenter and click events.
    // To avoid double action, we can set a 'lock' flag and then immediately
    // clear it when the event loop concludes
    this.menuActionLock = true;

    setTimeout( () => {
      this.menuActionLock = false;
    }, 0);
  }

  operateSubMenu($el) {
    // the behavior of the menus changes depending
    // on the active breakpoint
    switch(breakpoint()) {
      case "large":
        this.toggleFlyoutMenus([$el, this.$openItem()]);
        break;
      case "medium":
      case "small":
        this.toggleCollapsingMenu($el);
        break;
      default:
        return;
    }
  }

  // explicity close a submenu
  closeSubMenu($el) {
    switch(breakpoint()) {
      case "large":
        this.closeFlyoutMenu($el);
        break;
      case "medium":
      case "small":
        this.closeCollapsingMenu($el);
        break;
      default:
        return;
    }
  }

  // explicity open a submenu
  openSubMenu($el) {
    switch(breakpoint()) {
      case "large":
        this.openFlyoutMenu($el);
        break;
      case "medium":
      case "small":
        this.openCollapsingMenu($el);
        break;
      default:
        return;
    }
  }

  toggleNavMenu() {
    if (this.$el.hasClass(this.openClass)) {
      this.$navMenu.slideUp(300);
      this.ariaCollapse(this.$el);
    } else {
      this.$navMenu.slideDown(300);
      this.ariaExpand(this.$el);
    }

    this.$el.toggleClass(this.openClass);
  }

  ariaExpand($el) {
    $el.attr("aria-expanded", true);
  }

  ariaCollapse($el) {
    $el.attr("aria-expanded", false);
  }

  toggleFlyoutMenus(items) {
    // In case the same item is added twice (by clicking on the currently open item, for example)
    // only apply behavior to each element once
    items.reduce( ($toggled, $item) => {
      if ($toggled.index($item) === -1) {
        if ($item.hasClass(this.openClass)) {
          this.closeFlyoutMenu($item);
          this.closeMenuAttributes($item);
          this.ariaCollapse($item.find(".js-submenu"));
        } else {
          this.openFlyoutMenu($item);
          this.openMenuAttributes($item);
          this.ariaExpand($item.find(".js-submenu"));
        }

        return $toggled.add($item);
      }
    }, $());
  }

  openFlyoutMenu($item) {
    this.openMenuAttributes($item);
  }

  closeFlyoutMenu($item) {
    this.closeMenuAttributes($item);
  }


  toggleCollapsingMenu($item) {
    if ($item.hasClass(this.openClass)) {
      this.closeCollapsingMenu($item);
      this.closeMenuAttributes($item);
    } else {
      this.openCollapsingMenu($item);
      this.openMenuAttributes($item);
    }
  }

  openCollapsingMenu($item) {
    const $submenu = $item.find(".js-submenu");
    $submenu.slideDown(300);
  }

  closeCollapsingMenu($item) {
    const $submenu = $item.find(".js-submenu");
    $submenu.slideUp(300);
  }

  openMenuAttributes($item) {
    $item.addClass(this.openClass);
    $item.find("a").attr("tabindex", 0);
  }

  closeMenuAttributes($item) {
    $item.removeClass(this.openClass);
    $item.find("a").attr("tabindex", -1);
  }

  adjustFlyoutMenuAlignment(idx, item) {
    // if the menu is going to be rendered offscreen,
    // we need to push it back.
    let $item = $(item);
    let $menu = $item.find(".js-submenu");
    const left = $item.offset().left;
    const menuWidth = $menu.outerWidth();
    const windowWidth = $(window).width();
    const diff = windowWidth - (left + menuWidth);

    const newLeft = diff < 0 ? diff : 0;
    $menu.css({ left: `${newLeft}px` });
  }

  $openItem() {
    return this.$el.find(`.${this.openClass}`);
  }

  downInContext(context) {
    if (!context) {
      return;
    }

    if (!context.$parent && context.$el.hasClass("js-has-submenu")) {
      this.operateSubMenu(context.$el);
      context.$el.find("a:first").trigger("focus");
    } else if (context.$parent && context.$next) {
      context.$next.trigger("focus");
    }
  }

  upInContext(context) {
    if (!context) {
      return;
    }

    if (context.$parent && !context.$prev) {
      this.operateSubMenu(context.$el);
      context.$parent.trigger("focus");
    } else if (context.$parent && context.$prev) {
      context.$prev.trigger("focus");
    }
  }

  collapseInContext(context) {
    this.closeSubMenu(context.$el);
  }

  toggleInContext(context) {
    this.operateSubMenu(context.$el);
  }

  rightInContext(context) {
    if (!context) {
      return;
    }

    if (context.$parent) {
      const $nextMenu = context.$parent.nextAll(".js-has-submenu").first();
      this.operateSubMenu($nextMenu);
      $nextMenu.find("li a").first().trigger("focus");
    } else if (context.$next) {
      context.$next.trigger("focus");
    }
  }

  leftInContext(context) {
    if (!context) {
      return;
    }

    if (context.$parent) {
      const $prevMenu = context.$parent.prevAll(".js-has-submenu").first();
      this.operateSubMenu($prevMenu);
      $prevMenu.find("li a").first().trigger("focus");
    } else if (context.$prev) {
      context.$prev.trigger("focus");
    }
  }

  // Provides an object with the currently focused element,
  // prev and next focusable elements, and the menu parent
  // if applicable
  focusContext() {
    const $focusEl = $(document.activeElement);

    // return nothing if focus doesn't exist, or is not in our menu
    if (!$focusEl.length || $focusEl.closest(".js-menu").length === 0) {
      return;
    }

    // get the next focusable item
    const $next = ($el) => {
      // If we're focused on an <a>, move up to parent <li>
      if ($el[0].nodeName === "A") {
        $el = $el.parent();
      }

      // get immediate sibling
      let $nextEl = $el.next();

      // if no tabindex defined, select the inner <a> instead
      if (typeof($nextEl.attr("tabindex")) === "undefined") {
        $nextEl = $nextEl.children("a:first");
      }

      return $nextEl.length === 0 ? null : $nextEl;
    };

    // get the prev focusable item
    const $prev = ($el) => {
      // If we're focused on an <a>, move up to parent <li>
      if ($el[0].nodeName === "A") {
        $el = $el.parent();
      }

      // Get the immediate sibling
      let $prevEl = $el.prev();

      // if no tabindex defined, select the inner <a> instead
      if (typeof($prevEl.attr("tabindex")) === "undefined") {
        $prevEl = $prevEl.children("a:first");
      }

      return $prevEl.length === 0 ? null : $prevEl;
    };

    // get a parent
    const $parent = ($el) => {
      const $parentEl = $el.parents("ul").parents(".js-nav-item");
      return $parentEl.length === 0 ? null: $parentEl;
    };

    return {
      $el: $focusEl,
      $next: $next($focusEl),
      $prev: $prev($focusEl),
      $parent: $parent($focusEl)
    };
  }
}
